<template>
  <div>
    <div class="browswer-check" id="browser-check" v-if="browser == 'ie' && showBrowser && showBrowerCode">
        <p class="txt">{{ $i18nUtil.trans("message.HomeContents.004","크롬 브라우저에 최적화되어 있습니다") }}</p>
        <button type="button" class="close" @click="closeBrowser(1)"><span class="hide">닫기</span></button>
    </div>
    <div class="mas010">
      <div class="mas010-header" v-html="$i18nUtil.trans('message.HomeContents.001','<b>{user}님,</b><br />이번 한 주는 어떠셨나요? <br />업데이트 된 미확인 업무를 검토해보세요.', {user: loginUserName})">
      </div>
      <!-- 새로 요청 받은 작업 start -->
      <RequestedJobs :newWorkList="newWorkList" />
      <!-- 새로 요청 받은 작업 end -->
      <!-- 최근 업데이트 start -->
      <UpdateWorkspace ref="updateWorkspace" @initNewWorkList="initNewWorkList"
        :projectList="projectList" :browser="browser" />
      <!-- 최근 업데이트 end -->
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import MainExpireExtension from "@/components/cowork/general/main/modal/MainExpireExtension";
import RequestedJobs from "./RequestedJobs";
import UpdateWorkspace from "./UpdateWorkspace.vue";

export default {
  data() {
    return {
      /* tenantId */
      tenantId: localStorage.getItem("tenantId"),
      cnt: 0,
      loginUserName: null,
      userList: [],
      //            paperList : [],
      newWorkList: [],
      allWorkList: [],
      projectList: [],
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
      todoTabIndex: 0,
      browser : null,
      showBrowser : false,
      showBrowerCode: false
    };
  },
  components: {
    RequestedJobs,
    UpdateWorkspace
  },
  created() {
    // 보드나 과제에서 /general/home 로 이동 후 
    // 다시 과제접근할때 세션이 살아있어 이전 과제로 이동하는 문제
    // 2021-07-13 : 조성기 
    if(window.sessionStorage.length != 0){
      // window.sessionStorage.clear();
      window.sessionStorage.removeItem("dashboard");
      window.sessionStorage.removeItem("moveBoard");
      window.sessionStorage.removeItem("prevBtn");
    }

    this.checkBrowser();
    this.checkCookie();
  },
  async mounted() {
    this.init();
    await this.getNewDecision(); /* 새로 요청 받은 의사 결정 5건 */
    await this.getNewTodo(); /* 새로 요청 받은 할 일 5건 */
    await this.getNewFeedback(); /* 새로 요청 받은 피드백 5건 */
    await this.sortWorkList();
    await this.getProjectList();
    if (this.projectList.length > 0) {
      await this.$refs.updateWorkspace.getCategoryList(this.projectList[0], 0);
    }
    this.isIntroCheck();
  },
  computed: {
    ...mapState("introInfo", ["isInternalUser"]),
  },
  methods: {
    ...mapActions("modals", ["showDialog"]),
    ...mapActions("modals", ["showModal"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapMutations("introInfo", ["setIntroInfo"]),

    init() {
      this.loginUserName = localStorage.getItem("userName");
    },
    /* 새로 요청 받은 업무 날짜순으로 정렬 */
    sortWorkList() {
      let workList = this.allWorkList;
      if (workList.length > 0) {
        const sortingWorkList = workList.sort(function (a, b) {
          a = new Date(a.regDate);
          b = new Date(b.regDate);
          if(a > b) {
            return -1;
          } 
          if(a  < b) {
            return 1;
          }
          return 0;
        });
        let cnt = 0;
        if (sortingWorkList.length > 5) {
          cnt = 5;
        } else {
          cnt = sortingWorkList.length;
        }
        for (let i = 0; i < cnt; i++) {
          this.newWorkList.push(sortingWorkList[i]);
        }
      }
    },
    /* 새로 요청 받은 의사 결정 5건 */
    async getNewDecision() {
      let obj = this;
      let reqData = {
        url: "/api/copaper/decision/getDecisionNewFive",
        method: "post",
      };
      await obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          if (res.errorCode != null) {
            console.log(res.errorCode);
          } else {
            if (res.result.length !== 0) {
              let decisionList = res.result;
              decisionList.forEach((element) => {
                let item = {
                  type: "DEC",
                  obj: element,
                  id: element.deciId,
                  regDate: element.regDate,
                  contents: element.contents,
                  extParam1: '',
                  extParam2: ''
                };
                obj.allWorkList.push(item);
              });
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    /* 새로 요청 받은 할 일 5건 */
    async getNewTodo() {
      let obj = this;
      let reqData = {
        url: "/api/copaper/todo/getTodoNewFive",
        method: "post",
      };
      await obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          if (res.errorCode != null) {
            console.log(res.errorCode);
          } else {
            if (res.result.length !== 0) {
              let todoList = res.result;
              todoList.forEach((element) => {
                let item = {
                  type: "TODO",
                  obj: element,
                  id: element.todoId,
                  regDate: element.regDate,
                  contents: element.todoTitle,
                  extParam1: '',
                  extParam2: ''
                };
                obj.allWorkList.push(item);
              });
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    /* 새로 요청 받은 피드백 5건 */
    async getNewFeedback() {
      let obj = this;
      let reqData = {
        url: "/api/copaper/feedback/getFeedbackNewFive",
        method: "post",
      };
      await obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          if (res.errorCode != null) {
            console.log(res.errorCode);
          } else {
            if (res.result.length !== 0) {
              let feedbackList = res.result;
              feedbackList.forEach((element) => {
                let item = {
                  type: "FEEDBACK",
                  obj: element,
                  id: element.feedbackId,
                  regDate: element.regDate,
                  contents: element.feedbackReqMsg,
                  extParam1: element.paperId,
                  extParam2: element.qrtCd
                };
                obj.allWorkList.push(item);
              });
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },    
    async getProjectList() {
      let obj = this;
      let reqData = {
        url: "/api/cogroup/project/getProjectListOrderByModDate",
        method: "post",
        params: {
          limit: "5",
        },
      };
      await obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          if (res.errorCode != null) {
            console.log(res.errorCode);
          } else {
            if (res.result != null) {
              obj.projectList = res.result.data;
              obj.projectCount = res.result.projectCount;
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    getBoardList(categoryMid, projectId) {
      let obj = this;
      //obj.currentTab = index;
      let reqData = {
        url: "/api/copaper/paper/getCategoryPaperList",
        method: "post",
        params: {
          categoryMid: categoryMid,
          projectId: projectId,
        },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          if (res.errorCode != null) {
            console.log(res.errorCode);
          } else {
            if (res.result != null) {
              let oriList = res.result.paperList.content;
              let list = [];
              let list2 = [];
              let map = {};
              oriList.forEach((element) => {
                //obj.paperList.push(element);
                list.push(element);
              });
              map = { categoryMid: categoryMid, list: list };
              obj.paperList.push(map);
              console.log(obj.paperList);
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    getPaperUserList(paperId) {
      let obj = this;
      let reqData = {
        url: "/api/copaper/paperuser/getPaperUserList",
        method: "post",
        params: {
          paperId: paperId,
        },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          if (res.errorCode != null) {
            return;
          }
          if (res.result !== null) {
            obj.userList = res.result.userList;
            obj.userCount =
              res.result.userList == null ? 0 : res.result.userList.length;
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    /* 새로 요청 받은 작업 할 일 삭제 시 데이터 다시 가져옴 */
    async initNewWorkList() {
      // 초기화
      this.newWorkList = [];
      this.allWorkList = [];
      await this.getNewDecision();
      await this.getNewTodo();
      await this.getNewFeedback();
      await this.sortWorkList();
    },
    checkBrowser(){
      let agent = navigator.userAgent.toLowerCase();
        if ( (navigator.appName == 'Netscape' && navigator.userAgent.search('Trident') != -1) || (agent.indexOf("msie") != -1) ) {
          this.checkBrowserCode();
          this.browser = "ie";
        }
        else if (agent.indexOf("chrome") != -1) {
          this.browser = "chrome";
        }
      console.log(this.browser);
    },
    checkCookie(){
      if(this.getCookie("divpop1") != "Y"){         
         this.showBrowser = true;
      }      
    },
    setCookie(name, value, expiredays){
      let todayDate = new Date();
      todayDate.setDate( todayDate.getDate() + expiredays );
      document.cookie = name + '=' + escape( value ) + '; path=/; expires=' + todayDate.toGMTString() + ';'
    },
    getCookie(name) { 
      let obj = name + "="; 
      let x = 0;
      let endOfCookie = ''; 
      while( x <= document.cookie.length ){
          let y = (x+obj.length);
          if(document.cookie.substring( x, y ) == obj) {
          if((endOfCookie=document.cookie.indexOf( ";", y )) == -1 ) {
              endOfCookie = document.cookie.length;
          }
          return unescape( document.cookie.substring( y, endOfCookie ) );
          }
          x = document.cookie.indexOf( " ", x ) + 1;
          if ( x == 0 ) break;
      }
      return "";
    },
    closeBrowser(key) {
      this.setCookie('divpop'+key, 'Y' , 3);
      this.showBrowser = false;
    },
    /* 인트로 & 개인정보활용동의 & 계정만료 화면 유무 체크 */
    isIntroCheck() {
      let obj = this;
      let reqData = {
          url: "/api/auth/isIntroCheck",
          method: "post",
          params: {}
      };
      obj
      .COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        if(res.errorCode !== null) {
          console.log(res.errorCode)
        } else {
          if(res.result !== null) {
            let isPrivacy = res.result.isPrivacy;
            let isExpire = res.result.isExpire;
            let isInternalUser = res.result.isInternalUser;
            obj.setIntroInfo({
              isExpire : isExpire,
              isPrivacy : isPrivacy,
              isInternalUser : isInternalUser
            });
            if(isExpire === false && isPrivacy !== false) {  /* 계정만료 레이어 노출 */
              obj.handleExpire();
            }
          }
        }
      })
      .catch(function(err) {
        console.log(err);
      })
    },
    /* 계정만료연장 레이어 노출 */
    handleExpire() {
      if(!this.isExpire) {
        const modalInfo = {
          width: "800px",
          obj: this.$modal,
          urlPath : this.path,
          type : this.type,
          component: MainExpireExtension
        };
        this.showModal(modalInfo);
      }
    },
    checkBrowserCode(){
      let obj = this;
      let reqData = {
        url : "/api/org/getCodeValueList",
        method : "post",
        params : {
          cdCategory: 'tenant.env',
          cdKey: 'browser.code.yn'  
        }
      };
      obj
      .COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        if (res.result !== null) {
          obj.showBrowerCode = res.result[0].cdValue == "true" ? true : false;
        }
      })
      .catch(function(err) {
          console.log(err);
      });
    }
  },
};
</script>

<style scoped>
/* .backwards::before, .backwards::before {
  top: auto;
  bottom: -6px;
  -webkit-transform: rotate(
    180deg
  );
  transform: rotate(
    180deg
    );
}
.backwards::before {
    top: auto; bottom: -8px;
    transform: rotate(180deg);
} */
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/home/base/HomeContents.vue